export default __webpack_public_path__ + "f04d936.png";